var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"details-button",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":_vm.buttonHandler}},[_vm._v(" 🔍 Descrizione ")])}
var staticRenderFns = []

export { render, staticRenderFns }